import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Event from '../../entities/event';
import Deadline from '../../entities/deadline';
export function deleteEvent(event: Event, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = event.id;}
const _work = workingSet();
store.getState().deadlines.getMappingFor('eventId', event.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.eventId === event.id) {
_deadline.eventId = null;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});



event.status = 'D';
event.addedOn = newHRTimestamp();
event.addedBy = getCurrentUserId();
event.importSource = targetImportSource;
event.importId = mergeId;
store.dispatch(Actions.EventActions.removeEventQueue(event));
}
export function replaceEvent(event: Event, replaceWith: Event, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = event.id;}
const _work = workingSet();
store.getState().deadlines.getMappingFor('eventId', event.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.eventId === event.id) {
_deadline.eventId = replaceWith.id;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});



return event;
}
export function deleteImpactEvent(event: Event) {
const impacts: string[] = [];
const state = store.getState();
const deadlineEventIdImpact = state.deadlines.getMappingFor('eventId', event.id).filter(deadline => deadline.status !== 'D');
deadlineEventIdImpact.forEach(() => impacts.push('deadlines'));



return util.countDistinct(impacts);
}
